import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-create-entrevista',
  templateUrl: './create-entrevista.component.html',
  styleUrls: ['./create-entrevista.component.scss']
})
export class CreateEntrevistaComponent implements OnInit {

  displayedColumns = ['NOMBRE', 'BORRAR'];

  listaSub = [];
  dataSource;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<CreateEntrevistaComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }
  operacion = 'createentrevista';
  identrevista = '';
  idpais;

  ngOnInit() {
    this.idpais = this.data.entrevista.IDPAIS;
    if (this.data.operacion == 'Editar') {
      let SUBS = {
        IDENTREVISTA: this.data.entrevista.identrevista,
        IDPADRE: this.localSave.get('usuarioPGV').IDU,
        IDAREA: this.localSave.get('usuarioPGV').IDAREA
      }
      //console.log(SUBS);
      this.gateway.save('getsubentrevistas', SUBS).then((result) => {
        // console.log(this.data.entrevista.nivelcontacto);
        let aux: any = result;
        this.listaSub = aux.rows;
        this.operacion = 'editentrevista';
        this.identrevista = this.data.entrevista.identrevista;
        this.grupoVal.controls.NOMBRE.setValue(this.data.entrevista.nombre);
        this.grupoVal.controls.NIVEL.setValue(this.data.entrevista.nivelcontacto);
        this.dataSource = new MatTableDataSource<any>(this.listaSub);
      }
      ).catch(function (e) {
      });
    }
    this.dataSource = new MatTableDataSource<any>(this.listaSub);
  }

  addSubEntrevista() {
    let i = 0;
    const index = this.listaSub.findIndex(sub => sub.nombre.toLowerCase() === (this.grupoVal.controls.NOMBRESUB.value.trim()).toLowerCase());
    if (index > -1) {
      this.snackbar.open('SubEntrevista ya existe', '', {
        duration: 3000
      });
      this.dataSource = new MatTableDataSource<any>(this.listaSub);
    } else {
      this.listaSub.push({ nombre: this.grupoVal.controls.NOMBRESUB.value.trim() });
      this.grupoVal.controls.NOMBRESUB.setValue('');
      this.dataSource = new MatTableDataSource<any>(this.listaSub);
    }
  }

  borrarSub(element) {
    let auxind = -1;
    auxind = this.listaSub.indexOf(element);
    this.listaSub.splice(auxind, 1)
    this.dataSource = new MatTableDataSource(this.listaSub);

    //this.dataSource = new MatTableDataSource<any>(this.listaSub);
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    this.spinner.show();
    let ENTREVISTA = {
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      NIVEL: this.grupoVal.controls.NIVEL.value,
      LISTA: this.listaSub,
      IDENTREVISTA: this.identrevista,
      IDPAIS: this.idpais,
      IDPADRE: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA
    }
    // console.log('========')
    //   console.log(this.operacion)
    //   console.log(ENTREVISTA)
    //   console.log('/=/=======')
    this.gateway.save(this.operacion, ENTREVISTA).then((result) => {
      // console.log('========')
      // console.log(result)
      // console.log('/=/=======')
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(60),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    NOMBRESUB: new FormControl('', [Validators.compose([
      Validators.minLength(2), Validators.maxLength(60)
      // ,Validators.pattern("['/' a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9 a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    NIVEL: new FormControl('', [Validators.compose([
      Validators.required
    ])]),
  });

  niveles = [
    { ID: 1, NOMBRE: 'Agendamiento' },
    { ID: 2, NOMBRE: 'No Agendamiento' }
  ];

}
